import { components } from "react-select";
import CloseIcon from "./close-icon";
import DropdownIcon from "./dropdown-icon";
import CheckmarkIcon from "./checkmark-icon";
import classNames from "classnames";

// Custom Option component with custom checkbox
export const Option = (props) => {
  const { isSelected, label } = props;
  return (
    <div>
      <components.Option {...props} className="multi-select-custom-option">
        <div className={classNames("custom-checkbox", { selected: isSelected })}>
          <CheckmarkIcon />
        </div>
        <label>{label}</label>
      </components.Option>
    </div>
  );
};

export const MultiValueRemove = (props) => {
  return (
    <components.MultiValueRemove {...props}>
      <CloseIcon />
    </components.MultiValueRemove>
  );
};

// taken from the docs: https://react-select.com/components search for "ClearIndicator"
export const ClearIndicator = (props) => {
  const {
    children = <CloseIcon />,
    getStyles,
    innerProps: { ref, ...restInnerProps }
  } = props;
  return (
    <div {...restInnerProps} ref={ref} style={getStyles("clearIndicator", props)}>
      <div className="action-indicator">{children}</div>
    </div>
  );
};

// same as ClearIndicator
export const DropdownIndicator = (props) => {
  const {
    children = <DropdownIcon />,
    getStyles,
    innerProps: { ref, ...restInnerProps }
  } = props;
  return (
    <div {...restInnerProps} ref={ref} style={getStyles("clearIndicator", props)}>
      <div className="action-indicator">{children}</div>
    </div>
  );
};
